import React, { FC, RefObject } from 'react';

import { useLiveZoneOccupancy } from 'hooks/dashboard/widgets/useLiveZoneOccupancy';

import { ZoneGuardsSelect } from './zone-guards-select';
import { ZoneGuardOccupancy } from './zone-guard-occupancy';

import styles from './styles.module.css';

interface ILiveZoneOccupancyWidgetProps {
  uid: string;
  reduxKey: string;
  expanded: boolean;
  customRef: RefObject<any>;
  update(): void;
  sizeChange(layout: any): void;
}

export const LiveZoneOccupancyWidget: FC<ILiveZoneOccupancyWidgetProps> = (props) => {
  const { processorId, occupancyProps, selectZoneGuard } = useLiveZoneOccupancy(props);

  return (
    <div className={`${styles.wrapper} widget-scroll-container`}>
      {processorId ? (
        <ZoneGuardOccupancy processorId={processorId} {...occupancyProps} />
      ) : (
        <ZoneGuardsSelect value={processorId || null} onChange={selectZoneGuard} />
      )}
    </div>
  );
};
